import React from 'react';
import { Mic, Loader2 } from 'lucide-react';

interface AudioMessageBubbleProps {
  audioUrl: string | null;
  fileName?: string | null;
  duration?: number | null;
  aiTranscription?: string | null;
  processingStatus?: 'pending' | 'processing' | 'completed' | 'error' | null;
  timestamp?: string;
}

export const AudioMessageBubble: React.FC<AudioMessageBubbleProps> = ({ 
  duration,
  aiTranscription,
  processingStatus,
  timestamp 
}) => {
  const formatDuration = (seconds: number | null | undefined) => {
    if (!seconds) return '0:00';
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="flex justify-end mb-2">
      <div className="bg-[#DCF8C6] rounded-lg px-3 py-2 max-w-[85%] shadow-sm">
        <div className="flex items-center gap-3">
          <div className="flex-shrink-0 w-10 h-10 rounded-full bg-white/50 flex items-center justify-center">
            {processingStatus === 'processing' ? (
              <Loader2 className="h-5 w-5 text-gray-600 animate-spin" />
            ) : (
              <Mic className="h-5 w-5 text-gray-600" />
            )}
          </div>
          <div className="flex-1">
            <div className="h-6 flex items-center">
              <div className="flex-1 h-1 bg-gray-300 rounded-full">
                <div className="w-0 h-full bg-gray-600 rounded-full"></div>
              </div>
            </div>
            <p className="text-xs text-gray-600 mt-1">
              {formatDuration(duration)}
            </p>
          </div>
        </div>
        
        {aiTranscription && (
          <div className="mt-2 pt-2 border-t border-gray-300">
            <p className="text-xs text-gray-600 italic">
              "{aiTranscription}"
            </p>
          </div>
        )}
        
        <div className="flex justify-end items-center gap-1 mt-1">
          <span className="text-[10px] text-gray-600">
            {timestamp || new Date().toLocaleTimeString('es', { hour: '2-digit', minute: '2-digit' })}
          </span>
        </div>
      </div>
    </div>
  );
};
